import { useCallback, useState } from "react";
import { Send, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmt } from "./meta";
import { ApplyDialog } from "./ApplyDialog";

/** Sticky bar shown while rows or whole domains are ticked. */
export function ApplyBar({ run, sel, onClear, onStarted, busy }) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const n = sel.seqs.size;
  const d = sel.domains.size;
  if (!n && !d) return null;
  return (
    <>
      <div className="sticky bottom-4 z-20 mx-auto flex w-fit items-center gap-4 rounded-full border border-slate-800 bg-slate-900 py-2 pl-5 pr-2 text-sm text-white shadow-2xl shadow-slate-900/30" data-testid="bsp-apply-bar">
        <span data-testid="bsp-apply-selection">
          {n ? `${fmt(n)} row${n === 1 ? "" : "s"}` : ""}{n && d ? " + " : ""}{d ? `${fmt(d)} whole domain${d === 1 ? "" : "s"}` : ""} ticked</span>
        <button type="button" onClick={onClear} className="flex items-center gap-1 text-xs text-slate-400 transition-colors hover:text-white" data-testid="bsp-apply-clear"><X className="h-3.5 w-3.5" /> Clear</button>
        <Button size="sm" onClick={() => setOpen(true)} disabled={busy} className="rounded-full bg-emerald-500 text-white hover:bg-emerald-400" data-testid="bsp-apply-open">
          <Send className="h-3.5 w-3.5" /> {busy ? "Apply running…" : "Apply to Stax Bill…"}</Button>
      </div>
      {open && <ApplyDialog run={run} sel={sel} onClose={close} onStarted={(id) => { setOpen(false); onStarted(id); }} />}
    </>
  );
}
